import { Box } from '@mui/material';
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import ChatBubbleOutlineOutlinedIcon from '@mui/icons-material/ChatBubbleOutlineOutlined';
import HubOutlinedIcon from '@mui/icons-material/HubOutlined';

const styles = {
  chatgpt: { color: '#0b8066', background: '#eaf8f3' },
  claude: { color: '#b65f3c', background: '#fff2ea' },
  mcp: { color: '#1570ef', background: '#eef4ff' },
};

export default function ProviderMark({ provider = 'mcp', size = 48 }) {
  const key = provider.toLowerCase();
  const style = styles[key] || styles.mcp;
  const icon = key === 'chatgpt'
    ? <ChatBubbleOutlineOutlinedIcon />
    : key === 'claude' ? <AutoAwesomeOutlinedIcon /> : <HubOutlinedIcon />;

  return (
    <Box sx={{ width: size, height: size, flex: `0 0 ${size}px`, display: 'grid', placeItems: 'center', borderRadius: 2.5, color: style.color, bgcolor: style.background, '& svg': { fontSize: size * 0.52 } }}>
      {icon}
    </Box>
  );
}
